<template>
  <lateral-modal
    id="alertsModal"
    :title="$t('alerts_modal_title')"
    @close="closeModal"
  >
    <template slot="content">
      <div v-if="alertsReady">
        <template v-for="alertSetting in alertsSettings">
          <div
            v-if="alertSetting.type.code === ALERTS.DUPLICATE"
            :key="alertSetting.id"
            class="input--toggle-block"
          >
            <toggle-switch
              :status.sync="alertSetting.enabled"
              :label="'alerts_modal_duplicated'"
              :labelClass="'Label Label--text'"
              @change="updateAlert(alertSetting)"
            ></toggle-switch>
            <p class="input--toggle-block-description">{{ $t('alerts_modal_duplicated_description') }}</p>
          </div>
          <div
            v-else-if="alertSetting.type.code === ALERTS.WITHOUT_TICKET"
            :key="alertSetting.id"
            class="input--toggle-block"
          >
            <toggle-switch
              :status.sync="alertSetting.enabled"
              :label="'alerts_modal_empty_receipt'"
              :labelClass="'Label Label--text'"
              @change="updateAlert(alertSetting)"
            ></toggle-switch>
            <p class="input--toggle-block-description">{{ $t('alerts_modal_empty_receipt_description') }}</p>
          </div>
          <div
            v-else-if="alertSetting.type.code === ALERTS.OUT_OF_ASSIGNED_TIME"
            :key="alertSetting.id"
            class="input--toggle-block"
          >
            <toggle-switch
              :status.sync="alertSetting.enabled"
              :label="'alerts_modal_out_of_office'"
              :labelClass="'Label Label--text'"
              @change="updateAlert(alertSetting)"
            ></toggle-switch>
            <p class="input--toggle-block-description">{{ $t('alerts_modal_out_of_office_description') }}</p>
            <div
              v-if="alertSetting.enabled"
              class="alerts-day-of-week"
            >
              <div
                v-for="(dayOfWeek, index) in Object.keys(alertSetting.config)"
                :key="index"
                class="alerts-day-of-week--container"
              >
                <input-checkbox
                  :id="`dayOfWeek${index}`"
                  :value.sync="alertSetting.config[dayOfWeek].enabled"
                  @click="updateAlert(alertSetting)"
                >
                  <p
                    slot="input-label"
                    :class="{'disabled': !alertSetting.config[dayOfWeek].enabled}"
                  >{{$t(`day_of_week_${dayOfWeek}`)}}</p>
                </input-checkbox>
                <div
                  class="alerts-day-of-week--container-multiselect"
                  :class="{'disabled': !alertSetting.config[dayOfWeek].enabled}"
                >
                  <multiselect
                    :options="showHoursAvailables(alertSetting.config[dayOfWeek].finish, 'start')"
                    v-model="alertSetting.config[dayOfWeek].start"
                    :disabled="!alertSetting.config[dayOfWeek].enabled"
                    :allowEmpty="false"
                    selectLabel=""
                    selectedLabel=""
                    deselectLabel=""
                    placeholder=""
                    @input="updateAlert(alertSetting)"
                  >
                    <div
                      class="caret"
                      slot="caret"
                      slot-scope="{ toggle }"
                      @mousedown.prevent.stop="toggle"
                    >
                      <img
                        :src="!alertSetting.config[dayOfWeek].enabled ? require('@/assets/img/icons/icon-drop-down-disabled.svg') : require('@/assets/img/icons/icon-drop-down.svg')"
                        alt="arrow-down"
                      />
                    </div>
                  </multiselect>
                  <span class="alerts-day-of-week--to-range">{{$t('keyword_to_range')}}</span>
                  <multiselect
                    :options="showHoursAvailables(alertSetting.config[dayOfWeek].start, 'finish')"
                    v-model="alertSetting.config[dayOfWeek].finish"
                    :disabled="!alertSetting.config[dayOfWeek].enabled"
                    :allowEmpty="false"
                    selectLabel=""
                    selectedLabel=""
                    deselectLabel=""
                    placeholder=""
                    @input="updateAlert(alertSetting)"
                  >
                    <div
                      class="caret"
                      slot="caret"
                      slot-scope="{ toggle }"
                      @mousedown.prevent.stop="toggle"
                    >
                      <img
                        :src="!alertSetting.config[dayOfWeek].enabled ? require('@/assets/img/icons/icon-drop-down-disabled.svg') : require('@/assets/img/icons/icon-drop-down.svg')"
                        alt="arrow-down"
                      />
                    </div>
                  </multiselect>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else-if="alertSetting.type.code === ALERTS.AMOUNT_EXCEEDED"
            :key="alertSetting.id"
            class="input--toggle-block"
          >
            <toggle-switch
              :status.sync="alertSetting.enabled"
              :label="'alerts_modal_amount_exceeded'"
              :labelClass="'Label Label--text'"
              @change="updateAlert(alertSetting)"
            ></toggle-switch>
            <p class="input--toggle-block-description">{{ $t('alerts_modal_amount_exceeded_description') }}</p>
            <div v-if="alertSetting.enabled">
              <div
                v-for="(amountExceeded, index) in Object.keys(alertSetting.config)"
                :key="index"
                class="alerts-amount-exceeded--container"
              >
                <input-checkbox
                  :id="amountExceeded"
                  :value.sync="alertSetting.config[amountExceeded].enabled"
                  @click="updateAlert(alertSetting)"
                >
                  <p
                    slot="input-label"
                    :class="{'disabled': !alertSetting.config[amountExceeded].enabled}"
                  >{{$t(`alerts_modal_${amountExceeded}`)}}</p>
                </input-checkbox>
                <money-input
                  :id="amountExceeded"
                  :value.sync='alertSetting.config[amountExceeded].max'
                  :disabled='!alertSetting.config[amountExceeded].enabled'
                  :allowNegative='false'
                  :class="{'disabled': !alertSetting.config[amountExceeded].enabled}"
                  :placeholderDisabled="'expense_amount'"
                  @change="updateAlert(alertSetting)"
                ></money-input>
              </div>
            </div>
          </div>
          <div
            v-else-if="alertSetting.type.code === ALERTS.AMOUNT_DISTINCT_OCR"
            :key="alertSetting.id"
            class="input--toggle-block"
          >
            <toggle-switch
              :status.sync="alertSetting.enabled"
              :label="'alerts_modal_amount_distinct_ocr'"
              :labelClass="'Label Label--text'"
              @change="updateAlert(alertSetting)"
            ></toggle-switch>
            <p class="input--toggle-block-description">{{ $t('alerts_modal_amount_distinct_ocr_description') }}</p>
          </div>
          <div
          v-else-if="alertSetting.type.code === ALERTS.AMOUNT_DISTINCT_SUM_TAXES"
          :key="alertSetting.id"
          class="input--toggle-block">
            <toggle-switch
              :status.sync="alertSetting.enabled"
              :label="'alerts_modal_amount_distinct_sum_taxes'"
              :labelClass="'Label Label--text'"
              @change="updateAlert(alertSetting)"
            ></toggle-switch>
            <p class="input--toggle-block-description">{{ $t('alerts_modal_amount_distinct_sum_taxes_description') }}</p>

          </div>

        </template>
      </div>
      <div
        class="flex center"
        v-else
      >
        <spinner spinner-class-list="text-secondary"></spinner>
      </div>
    </template>
  </lateral-modal>
</template>

<script>
import { ALERTS } from '../../_constants/alertsConstants'
import { hoursADay15Minutes } from '@/utils/constants'
import Multiselect from 'vue-multiselect'
import MoneyInput from '@/components/Commons/Forms/MoneyInput'
import Spinner from '@/components/Commons/Spinner'
import ToggleSwitch from '@/components/Commons/Forms/ToggleSwitch'
import InputCheckbox from '@/components/Commons/Forms/InputCheckbox'
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import LateralModal from '@/components/Commons/Modals/LateralModal'

export default {
  components: { Multiselect, MoneyInput, Spinner, ToggleSwitch, InputCheckbox, LateralModal },
  mixins: [_modalHandlerMixin],
  data () {
    return {
      alertsReady: false,
      amountExceeded: {
        expense: {
          active: false,
          amount: null
        },
        reimbursement: {
          active: false,
          amount: null
        },
        mileage: {
          active: false,
          amount: null
        },
        diet: {
          active: false,
          amount: null
        }
      }
    }
  },
  computed: {
    ALERTS () {
      return ALERTS
    },
    alertsSettings () {
      return this.$store.getters['CompanyStore/AlertsSettingsStore/alertsSettings']
    },
    officeId () {
      return this.$store.getters['CompanyStore/currentCompany'].id
    }
  },
  methods: {
    showHoursAvailables (hour, state) {
      const hours = []
      hoursADay15Minutes.forEach(item => {
        if (state === 'start' && hour > item) {
          hours.push(item)
        } else if (state === 'finish' && item === '00:00') {
          hours.push('23:59')
        } else if (state === 'finish' && hour < item) {
          hours.push(item)
        }
      })

      return hours.sort()
    },
    updateAlert (alertSetting) {
      this.$store.dispatch('CompanyStore/AlertsSettingsStore/updateAlertsSettings', { ...alertSetting })
    }
  },
  created () {
    const promises = [this.$store.dispatch('CompanyStore/AlertsSettingsStore/fetchAlertsSettings')]

    Promise.allSettled(promises).then(() => {
      this.alertsReady = true
    })
  },
  beforeRouteUpdate (to, from, next) {
    this.closeModal()
    next()
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
#alertsModal {
  .Fuell-Toggle-switch {
    order: 1;
  }
  .Label--text {
    font-weight: 500;
    font-size: 15px;
    line-height: 24px;
    color: var(--text-heading);
  }
  .input--toggle-block {
    .d-flex {
      justify-content: space-between;
    }
    &-description {
      font-weight: 400;
      font-size: 15px;
      line-height: 24px;
      color: var(--text-body);
    }
  }
  .alerts-day-of-week {
    margin-bottom: 16px;
  }
  .alerts-amount-exceeded--container,
  .alerts-day-of-week--container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
    &-multiselect {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .multiselect {
        width: 80px;
        height: 46px;
        &.multiselect--disabled {
          background: transparent;
          color: var(--text-disabled) !important;
          opacity: 1;
          .caret {
            svg {
              border-color: var(--text-disabled) transparent transparent;
            }
          }
        }
        .multiselect__input {
          background-color: transparent;
        }
        .caret {
          height: 46px;
          width: 10px;
          margin-right: 0;
          padding: 4px 0;
          background: var(--fill-text-area);
        }
        &.multiselect--active {
          .multiselect__select {
            transform: none;
          }
        }
        .multiselect__tags {
          padding-right: 0;

          .multiselect__single {
            padding: 0;
          }
        }
        .multiselect__element {
          border-bottom: 1px solid var(--text-divider);
          &:last-child {
            border-bottom: none;
          }
        }
      }
    }
    div.Fuell-TableInput--container,
    div.Fuell-TableInput {
      width: 123px;
      height: 46px;
      padding: 14px 12px;
      background-color: var(--fill-text-area);
      border-radius: 4px;
      font-weight: 400;
      font-size: 15px;
      line-height: 18px;
      color: var(--text-body);
      input {
        background-color: var(--fill-text-area);
      }
      .Fuell-TableInput--icon-container {
        display: none;
      }
    }
    input.Fuell-TableInput {
      height: 20px;
      line-height: 18px;
      padding: 0;
    }
    .alerts-day-of-week--to-range {
      display: inline-block;
      height: 46px;
      width: 40px;
      padding-top: 14px;
      background: var(--fill-text-area);
      font-weight: 400;
      font-size: 15px;
      line-height: 18px;
      color: var(--text-placeholder);
      text-align: center;
    }
    .disabled {
      color: var(--text-disabled) !important;
      .alerts-day-of-week--to-range {
        color: var(--text-disabled) !important;
      }
    }
    label {
      display: flex;
      align-items: center;
      p {
        margin: 0 0 0 8px;
        font-weight: 400;
        font-size: 15px;
        line-height: 24px;
        color: var(--text-body);
      }
    }
  }
}
</style>
